import { Flex, Box } from "@chakra-ui/react";
import LullabiesListItem from "./LullabiesListItem";

function groupArrayByTwo(array) {
  return array.reduce((accumulator, currentValue) => {
    if (accumulator.length === 0) {
      accumulator[0] = [];
    }

    const currentIndex = accumulator.length - 1;

    if (
      accumulator[currentIndex].length === 0 ||
      accumulator[currentIndex].length === 1
    ) {
      accumulator[currentIndex].push(currentValue);
    } else {
      accumulator[currentIndex + 1] = [currentValue];
    }
    return accumulator;
  }, []);
}

export default function LullabiesList({
  lullabies,
  onDelete,
  onEdit,
  onAdd,
  audioController
}) {
  const groupedLullabies = groupArrayByTwo(Object.values(lullabies));
  const hasMoreThanOneLullaby = groupedLullabies[0]?.length > 1;

  return groupedLullabies.map((lullabyGroup, id) => {
    return (
      <Flex
        alignItems="start"
        justifyContent="space-between"
        mb="16px"
        key={id}
        sx={{
          "&:last-of-type": {
            mb: "0px"
          }
        }}
      >
        {lullabyGroup.map((lullaby) => {
          return (
            <Box key={lullaby.objectId} width="280px">
              <LullabiesListItem
                audioController={audioController}
                lullaby={lullaby}
                onDelete={
                  onDelete && hasMoreThanOneLullaby
                    ? () => onDelete(lullaby.objectId)
                    : null
                }
                onEdit={
                  onEdit && lullaby.source === "record"
                    ? () => onEdit(lullaby.objectId)
                    : null
                }
                onAdd={onAdd ? () => onAdd(lullaby.identifier) : null}
              />
            </Box>
          );
        })}
      </Flex>
    );
  });
}
